import { render, staticRenderFns } from "./ProductReg.vue?vue&type=template&id=053a33c6&scoped=true"
import script from "./ProductReg.vue?vue&type=script&lang=js"
export * from "./ProductReg.vue?vue&type=script&lang=js"
import style0 from "./ProductReg.vue?vue&type=style&index=0&id=053a33c6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053a33c6",
  null
  
)

export default component.exports